import {Pipe, PipeTransform} from '@angular/core';

/**
 * Works with the `@ClassMetaData` and `@PropMetaData` decorators to retrieve metadata from a class or property
 */
@Pipe({
	name: 'md',
	standalone: true,
})
export class MetaDataPipe<T extends Parameters<typeof ClassMetaData>[0] = Parameters<typeof ClassMetaData>[0]> implements PipeTransform {
	transform(classOrProperty: any, metadataKey?: keyof T, ...fnArgs: any[]): any {
		if (!classOrProperty) return null;
		classOrProperty = typeof classOrProperty === 'function' ? classOrProperty : classOrProperty.constructor;
		let metaDataObject: T;
		if (classOrProperty) {
			metaDataObject = Reflect.getMetadata(METADATA_DECORATOR_KEY.valueOf(), classOrProperty);
			if (!metadataKey && metaDataObject) return metaDataObject;
			if (metaDataObject && metaDataObject[metadataKey]) {
				const mdObjectRes = metaDataObject[metadataKey];
				if (fnArgs.length > 0 && typeof mdObjectRes === 'function') {
					return mdObjectRes(...fnArgs);
				}
				return mdObjectRes;
			}
		}
		if (classOrProperty._uniqueId) {
			debugger;
			console.warn(`Metadata not found for ${classOrProperty.name} with key ${String(metadataKey)}`);
		}
		return null;
	}
}

function isClass(obj: any): boolean {
	return !!obj.prototype && !!obj.prototype.constructor.name;
}

function isProperty(obj: any): boolean {
	return !isClass(obj);
}
